import { render, staticRenderFns } from "./FileChip.vue?vue&type=template&id=af3ad8de"
import script from "./FileChip.vue?vue&type=script&lang=js"
export * from "./FileChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports